module.exports = __webpack_public_path__ + "img/engagement-photo-2.02bded14.jpg";